import { ReactNode } from 'react';
import { classnames } from 'helpers/utils';
import styles from './settings-nav-item.module.scss';

type SettingsNavItemProps = {
  avatar: ReactNode;
  title: string;
  subtitle: string;
  active?: boolean;
  // Omitted for an item that is not a link (the account's own entry).
  onClick?: () => void;
};

// One entry of the Settings left-side navigation: the account (Account
// Settings) or one of the user's vaults (Vault Settings).
const SettingsNavItem = ({
  avatar,
  title,
  subtitle,
  active = false,
  onClick,
}: SettingsNavItemProps) => (
  <button
    type="button"
    className={classnames(styles.item, { [styles.active]: active })}
    onClick={onClick}
    disabled={!onClick}
    aria-current={active ? 'page' : undefined}
  >
    {avatar}
    <span className={styles.texts}>
      <span
        className={classnames(
          styles.title,
          'text__body__semi__bold__medium__gray900',
        )}
      >
        {title}
      </span>
      <span className="text__body__regular__small__gray600">{subtitle}</span>
    </span>
  </button>
);

export { SettingsNavItem };
